/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/useRejectManagementEmailForm"/>
import { FieldValues, useForm } from "react-hook-form";
import { IAttachmentItem } from "./emailAttachments/interfaces";  

export interface RejectManagementEmailWizardFormState {
    emailTo: string;
    messageSubject: string;
    sendCopy: boolean;
    content: string;
    sendToSupplier: boolean;
    attachments: IAttachmentItem[];
}

export const defaultState: RejectManagementEmailWizardFormState = {
    emailTo: "",
    messageSubject: "",
    sendCopy: true,
    content: "",
    sendToSupplier: true,
    attachments: [],
};

export const useRejectManagementEmailForm = () => {
  const { handleSubmit, control, reset, watch, formState, setError, clearErrors, setValue } = useForm({
    criteriaMode: "all",
    mode: "onChange",
    defaultValues: defaultState as FieldValues,
    reValidateMode: "onChange",
  });

  return { handleSubmit, control, reset, watch, defaultState, formState, setError, clearErrors, setValue };    
};
